// extracted by mini-css-extract-plugin
module.exports = {"sim-logo-container":"simLogo_sim-logo-container__UmMzT","sim-logo":"simLogo_sim-logo__1QZxK","sim-name":"simLogo_sim-name__2VHuk","sim-image":"simLogo_sim-image__1mtbo"};